<template>
  <div class="container banner">
    <!-- 
      Sonstige Methoden von Erweiterung:
    <div>
          kleinstes Startdatum der Promotion (aktiv)
          {{ $promotions.getMinStartFor('Custom:blackweek21') }}
          größtes Enddatum der Promotion (aktiv)
          {{ $promotions.getMaxEndFor('Custom:blackweek21') }}
          derzeitige Angebotsanzahl
          {{ $promotions.getOfferCountFor('Custom:blackweek21') }}
    </div> -->

    <BlackFriday v-if="$promotions.anyActiveFor('Custom:blackweek21')" />
    <Italy v-if="$promotions.anyActiveFor('Custom:greenstorm')" />
    <Valentine v-if="$promotions.anyActiveFor('Custom:valentin22')" />
    <Easter v-if="$promotions.anyActiveFor('Custom:ostern21')" />
    <MothersDay v-if="$promotions.anyActiveFor('Custom:muttertag21')" />
    <SummerSale v-if="$promotions.anyActiveFor('Custom:ssv2021')" />
    <Christmas v-if="$promotions.anyActiveFor('Custom:xmas21')" />

    <Italia v-if="$promotions.anyActiveFor('Custom:italia')" />
  </div>
</template>

<script>
//import BannerUtils from '@/common/banner-utils'

const BlackFriday = () => import(/* webpackChunkName: "blackfriday" */ '@/components/Banner/Adac/BlackFriday')
const Valentine = () => import(/* webpackChunkName: "valentine" */ '@/components/Banner/Adac/Valentine')
const Easter = () => import(/* webpackChunkName: "easter" */ '@/components/Banner/Adac/Easter')
const MothersDay = () => import(/* webpackChunkName: "mothersday" */ '@/components/Banner/Adac/MothersDay')
const SummerSale = () => import(/* webpackChunkName: "summersale" */ '@/components/Banner/Adac/SummerSale')
const Christmas = () => import(/* webpackChunkName: "christmas" */ '@/components/Banner/Adac/Christmas')
const Italy = () => import(/* webpackChunkName: "italy" */ '@/components/Banner/Piratinviaggio/Italy')
const Italia = () => import(/* webpackChunkName: "italia" */ '@/components/Banner/Piratinviaggio/Italia')

export default {
  name: 'Banners',
  components: {
    BlackFriday,
    Christmas,
    Italy,
    Valentine,
    Easter,
    MothersDay,
    SummerSale,
    Italia,
  },
  props: {},
  methods: {
    // isLive(start, end) {
    //   return BannerUtils.isLive(start, end)
    // },
  },
}
</script>

<style scoped lang="scss">
.banner {
  margin-top: 1rem;
  margin-bottom: 3rem;

  &:empty {
    margin: 0;
  }
}
</style>
